import { Match as e } from "effect";
const t = () => {
  const o = navigator.userAgent.toLowerCase();
  return e.value(o).pipe(
    e.withReturnType(),
    e.when(
      (r) => r.includes("edge"),
      () => "edge"
    ),
    e.when(
      (r) => r.includes("opera"),
      () => "opera"
    ),
    e.when(
      (r) => r.includes("brave"),
      () => "brave"
    ),
    e.when(
      (r) => r.includes("chrome"),
      () => "chrome"
    ),
    e.when(
      (r) => r.includes("firefox"),
      () => "firefox"
    ),
    e.when(
      (r) => r.includes("safari"),
      () => "safari"
    ),
    e.orElse(() => (console.warn("Could not detect browser name, defaulting to chrome"), "chrome"))
  );
}, n = (o) => e.value(o).pipe(
  e.withReturnType(),
  e.whenOr("chrome", "edge", "opera", "brave", () => "chromium"),
  e.when("firefox", () => "firefox"),
  e.when("safari", () => "safari"),
  e.orElse(() => (console.warn("Could not detect browser architecture, defaulting to chromium"), "chromium"))
), h = () => n(t()), i = (o) => e.value(o).pipe(
  e.withReturnType(),
  e.when("chromium", () => "behjakjklighlhiefaoogbalmenhbjid"),
  e.when("firefox", () => "verity-firefox-extension-prod"),
  e.when("safari", () => "com.yuja.verity-safari-extension-prod"),
  e.orElse(() => (console.warn("Could not detect browser extension id, defaulting to chrome extension id"), "behjakjklighlhiefaoogbalmenhbjid"))
), l = () => i(n(t())), s = (o) => e.value(o).pipe(
  e.withReturnType(),
  e.when("chromium", () => "https://chrome.google.com/webstore/detail/yuja-verity-for-test-proc/behjakjklighlhiefaoogbalmenhbjid"),
  e.when("firefox", () => "https://addons.mozilla.org/en-US/firefox/addon/yuja-verity-browser-extension/"),
  e.when("safari", () => "https://apps.apple.com/"),
  e.orElse(() => (console.warn("Could not detect browser extension store url, defaulting to chrome extension store url"), "https://chrome.google.com/webstore/detail/yuja-verity-for-test-proc/behjakjklighlhiefaoogbalmenhbjid"))
), c = () => s(n(t()));
export {
  n as getBrowserArch,
  i as getBrowserExtensionId,
  s as getBrowserExtensionStoreUrl,
  t as getBrowserName,
  h as getInferredBrowserArch,
  l as getInferredBrowserExtensionId,
  c as getInferredBrowserExtensionStoreUrl
};
